var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 15C1 14.4477 1.44772 14 2 14H14C14.5523 14 15 14.4477 15 15C15 15.5523 14.5523 16 14 16H2C1.44772 16 1 15.5523 1 15ZM4.29289 7.29289C4.68342 6.90237 5.31658 6.90237 5.70711 7.29289L7 8.58579L7 1C7 0.447716 7.44771 2.41411e-08 8 0C8.55228 -2.41411e-08 9 0.447715 9 1L9 8.58579L10.2929 7.29289C10.6834 6.90237 11.3166 6.90237 11.7071 7.29289C12.0976 7.68342 12.0976 8.31658 11.7071 8.70711L8.70711 11.7071C8.51957 11.8946 8.26522 12 8 12C7.73478 12 7.48043 11.8946 7.29289 11.7071L4.29289 8.70711C3.90237 8.31658 3.90237 7.68342 4.29289 7.29289Z",
    fill: "currentColor"
  })));
}

export default SvgDownload;